export enum FirebaseEventEnum {
  CLICK_NEWS = 'click_news',
  CLICK_EVENT = 'click_event',
  EVENT_ACTION = 'event_action',
  TEMPLATE_ACTION = 'template_action',
  HOUSE_ADS_ACTION = 'house_ads_action',
  CLICK_NEWS_EXTERNAL = 'open_news_on_provider',
  NEWS_CATEGORY_SELECTION = 'news_category_select',
  CLICK_PHARM_CARD = 'open_pharm_card',
  CLICK_PHARM_PHONE = 'call_pharm_phone',
  CLICK_PHARM_ADDRESS = 'call_pharm_address',
  CLICK_CALENDAR_WASTE_WIDGET = 'click_calendar_waste_widget',
  CLICK_WEATHER_WIDGET = 'click_weather_widget',
  CLICK_POI = 'click_poi',
  MAP_MODAL = 'map_modal_open',
  CLICK_VIDEO= 'click_video',
  PAGE_NAME= 'page_name',
  CLICK_JOB= 'click_job',
  CLICK_HOUSE_ADS_URL= 'click_house_ads_url',
  SEARCH_PLACE_NAME= 'search_place_name',
  PLACE_NAVIGATE= 'place_navigate'
}

export enum FirebaseValue {
    SETTINGS_PAGE = '[PAGE]_Impostazioni',
    TRANSPORT_PAGE = '[PAGE]_Pagina_Trasporti',
    RUBRICA_PAGE = '[PAGE]_Rubrica',
    PLACE_PAGE = '[PAGE]_Luoghi',
    JOBS_PAGE =  '[PAGE]_Jobs',
    HOME_ITEMS_PAGE =  '[PAGE]_Annunci_immobiliari',
    PHARMS_PAGE =  '[PAGE]_Farmacie',
    WASTE_PAGE =   '[PAGE]_Calendario_rifiuti',
    PRIVACY =   '[PAGE]_Privacy',
    PRIVACY_MODAL =   '[MODAL]_Privacy',
    SERVICE_PAGE =   '[PAGE]_Servizi',
    NEWS_PAGE =   '[PAGE]_News_Page',
    WEATHER_PAGE =   '[PAGE]_Meteo'
}
